import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  IAdMediaDimensions,
  adMediaDimensions,
  findLargestBreakpointMedia,
} from '@x/common/ads/ad-media.config';
import { TAdPlacement } from '@x/common/ads/ad.config';
import { CloudinaryModule } from '@x/common/cloudinary';
import { DeviceSizeMediaQueries, DeviceSizes } from '@x/common/responsive';
import { TShopAdMedia } from '@x/ecommerce/shop-client';

interface IShopAdPictureSource {
  url: string;
  mediaQuery: string;
  dimensions: IAdMediaDimensions;
}
interface IShopAdPicture {
  default: Omit<IShopAdPictureSource, 'mediaQuery'>;
  sources: IShopAdPictureSource[];
}

@Component({
  selector: 'x-ad-picture',
  standalone: true,
  imports: [CloudinaryModule],
  templateUrl: './ad-picture.component.html',
  styleUrl: './ad-picture.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdPictureComponent {
  pictureTag: IShopAdPicture | null = null;

  @Input() set media(media: TShopAdMedia[]) {
    const images = media.filter((m) => m.type === 'image');
    const placement = images[0].placement;
    if (!placement) this.pictureTag = null;

    this.pictureTag = this.getPictureTag(images, placement as TAdPlacement);
  }

  private getPictureTag(media: TShopAdMedia[], placement: TAdPlacement): IShopAdPicture | null {
    const defaultImage = findLargestBreakpointMedia(media);
    if (!defaultImage) return null;

    return {
      default: {
        url: defaultImage.url,
        dimensions: adMediaDimensions(
          defaultImage.mediaQuery.toUpperCase() as DeviceSizes,
          placement,
        ),
      },
      sources: media.map((m) => {
        const deviceSize = m.mediaQuery.toUpperCase() as DeviceSizes;
        const dimensions = adMediaDimensions(deviceSize, placement);

        return {
          url: m.url,
          mediaQuery: DeviceSizeMediaQueries[deviceSize],
          dimensions: dimensions,
        };
      }),
    };
  }
}
